export default {
  meta: {
    title: '门店地图门店品牌配置',
  },
};
